
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';
import { useState, } from 'react';

import Card from '@mui/material/Card';
import Table from '@mui/material/Table';

import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Backdrop, CircularProgress, } from '@mui/material';

import {
    useTable,
    emptyRows,
    TableNoData,
    getComparator,
    TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TablePaginationCustom,
} from '../../components/table';
import DashPlansTableRow from './DashPlans-table-row';
import Scrollbar from '../../components/scrollbar';
// import CompanyInfoDocTableRow from '../company-info-doc-table';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'date', label: 'DATE',color:'#1D53E7', fontWeight:600 },
    { id: 'plan_name ', label: 'PLAN NAME',color:'#1D53E7', fontWeight:600 },
    { id: 'amount', label: 'AMOUNT', width: 180 ,color:'#1D53E7', fontWeight:600},

    { id: 'Mode_of_payment', label: 'MODE OF PAYMENT', width: 180 ,color:'#1D53E7', fontWeight:600 },
    { id: 'status', label: 'STATUS', width: 180 ,color:'#1D53E7', fontWeight:600},
    // { id: '', width: 88 },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};
const dummyData = [
    // {
    //     id: 1,
    //     date: '12 Jun 2024',
    //     planName: 'Essentials Plan',
    //     amount: '₹11,313',
    //     paymentMode: 'UPI',
    //     status: 'Paid',
    //     invoice: 'View Invoice',
    // },
    // {
    //     id: 2,
    //     date: '12 Jun 2023',
    //     planName: 'Essentials Plan',
    //     amount: '₹13,813',
    //     paymentMode: 'Debit Card',
    //     status: 'Paid',
    //     invoice: 'View Invoice',
    // },
];
// ----------------------------------------------------------------------

export default function DashPlansTable() {
    const table = useTable();



    const [tableData, setTableData] = useState(dummyData);
    // const [tableData, setTableData] = useState([]);

    const [filters,] = useState(defaultFilters);
    // const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);


    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);


    // const fetchPlanData = useCallback(async () => {
    //     setLoading(true);

    //     try {
    //         const response = await axios.get(
    //             `${endpoints.company.owned_company_doc_list}${companyId}?page=${page}&limit=${rowsPerPage}&order_field=title`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         setErrorMessage('');
    //         setTableData(response?.data?.data);
    //         setTotalRecords(response?.data?.count);
    //     } catch (error) {
    //         console.log(error);
    //         if (!navigator.onLine) {
    //             setErrorMessage('You are currently offline. Please check your network connection.');
    //         } else if (error) {
    //             setErrorMessage(error.message || 'An error occurred while processing your request.');
    //             enqueueSnackbar(error.message, { variant: 'error' });
    //         } else {
    //             setErrorMessage('An unexpected error occurred.');
    //         }
    //     } finally {
    //         setLoading(false); // Hide loader
    //     }
    // }, [, page, rowsPerPage, token]);




    // useEffect(() => {
    //     fetchPlanData(); // Fetch the first page of data initially
    //     // eslint-disable-next-line
    // }, [page, rowsPerPage]);

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered.slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
    );




    const denseHeight = table.dense ? 56 : 56 + 20;

    const canReset = !isEqual(defaultFilters, filters);

    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;






    return (
        <>
            {loading && (
                <Backdrop open={loading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Container maxWidth={false}>
                <Card sx={{borderRadius:5}}>


                    <TableContainer sx={{ position: 'relative', overflow: 'unset',  }}>
                        <TableSelectedAction
                            dense={table.dense}
                            numSelected={table.selected.length}
                            rowCount={dataFiltered.length}
                            onSelectAllRows={(checked) =>
                                table.onSelectAllRows(
                                    checked,
                                    dataFiltered.map((row) => row.id)
                                )
                            }

                        />

                        <Scrollbar sx={{ maxHeight: '65vh', overflowY: { xs: 'auto', md: 'unset' } }}>
                            <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 460 }}>
                                <TableHeadCustom
                               
                                    order={table.order}
                                    orderBy={table.orderBy}
                                    headLabel={TABLE_HEAD}
                                    rowCount={dataFiltered.length}
                                    numSelected={table.selected.length}
                                    onSort={table.onSort}
                                    onSelectAllRows={(checked) =>
                                        table.onSelectAllRows(
                                            checked,
                                            dataFiltered.map((row) => row.id)
                                        )
                                    }
                                />

                                <TableBody>
                                    {dataFiltered
                                        // .slice(
                                        //     table.page * table.rowsPerPage,
                                        //     table.page * table.rowsPerPage + table.rowsPerPage
                                        // )
                                        .slice(
                                            table.page * table.rowsPerPage,
                                            // table.page * table.rowsPerPage + table.rowsPerPage
                                        )
                                        .map((row) => (
                                            <DashPlansTableRow
                                                key={row.id}
                                                row={row} />
                                        ))}

                                    <TableEmptyRows
                                        height={denseHeight}
                                        emptyRows={emptyRows(table.page, table.rowsPerPage, dataFiltered.length)}
                                    />

                                    <TableNoData notFound={notFound} />
                                </TableBody>
                            </Table>
                        </Scrollbar>
                    </TableContainer>

                    <TablePaginationCustom
                        count={totalRecords}
                        page={page - 1}
                        rowsPerPage={rowsPerPage}
                        onPageChange={(e, newPage) => setPage(newPage + 1)}
                        onRowsPerPageChange={(e) => {
                            const newRowsPerPage = parseInt(e.target.value, 10);
                            setRowsPerPage(newRowsPerPage);
                            setPage(1);
                        }}
                        dense={table.dense}
                        onChangeDense={table.onChangeDense}
                    />
                </Card>
            </Container>

        </>
    );
}

// ----------------------------------------------------------------------

function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;

    const stabilizedThis = inputData.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    inputData = stabilizedThis.map((el) => el[0]);

    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }

    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }

    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }

    return inputData;
}
DashPlansTable.propTypes = {
    companyId: PropTypes.string,
};
